export default __webpack_public_path__ + "static/media/resucitacion_cardiovascular_adultos.153540cd.pdf";